import React, { useState, useEffect } from "react"
import { Input, Flex } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import styles from "./index.module.css"
import SignedDocumentsTable from "./SignedDocumentsTable"
import FilterChips from "ui/FilterChips"
import MultiSelect from "components/common/MultiSelect"
import { useTranslation } from "react-i18next"
import { getTripList } from "store/trips"
import { useDispatch } from "react-redux"

const { Search } = Input
const statusOptions = [
  { label: "All", value: "all" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" }
]

export const SignedDocuments = () => {
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState("")
  const [selectedCategories, setSelectedCategories] = useState([])
  const [selectedExperiences, setSelectedExperiences] = useState([])
  const [tripsState, setTripsState] = useState([])
  const { t } = useTranslation()
  const onCategoryChange = (values) => {
    setSelectedCategories(values)
    // Add your filtering logic here based on selected categories
  }
  const onExperienceChange = (values) => {
    setSelectedExperiences(values)
    // Add your filtering logic here based on selected experiences
  }
  const handleSearch = (value) => {
    console.log("Searching for:", value)
    // Add your search logic here
  }
  useEffect(() => {
    // Fetch trips on mount
    const fetchTrips = async () => {
      try {
        const response = await dispatch(getTripList())
        // The response should be an array of trips
        if (Array.isArray(response)) {
          setTripsState(response)
        } else if (response && Array.isArray(response.data)) {
          // Handle case where response is an object with a data array
          setTripsState(response.data)
        } else {
          console.error("Unexpected response format from getTripList:", response)
          setTripsState([]) // Set to empty array to prevent map errors
        }
      } catch (error) {
        console.error("Error fetching trips:", error)
        setTripsState([]) // Set to empty array to prevent map errors
      }
    }

    fetchTrips()
  }, [dispatch])
  const experienceOptions = [
    { label: "All", value: "all" },
    ...tripsState.map((trip) => ({
      label: trip.title || "Untitled",
      value: String(trip.id)
    }))
  ]

  return (
    <div>
      <Flex className="my-xl" gap={20}>
        <Input
          placeholder="Search"
          prefix={<SearchOutlined className={styles.searchIcon} />}
          className={styles.searchInput}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onPressEnter={(e) => handleSearch(e.target.value)}
          allowClear
        />
        <MultiSelect
          value={selectedExperiences}
          onChange={onExperienceChange}
          options={experienceOptions}
          placeholder={selectedExperiences.length > 0 ? "Experiences" : t("All Experiences")}
          dropdownClassName={styles.dropdownButton}
        />
      </Flex>
      <Flex gap={8} align="center" flexWrap="wrap" className="mb-m">
        <FilterChips
          selectedCategories={selectedExperiences}
          categoryOptions={experienceOptions}
          setSelectedCategories={setSelectedExperiences}
        />
      </Flex>
      <SignedDocumentsTable searchValue={searchValue} selectedExperiences={selectedExperiences} />
    </div>
  )
}
